import Avatar from "@cloudscape-design/chat-components/avatar";
import { Modal } from "@cloudscape-design/components";
import React from "react";
import { useGlobalState } from "../../pages/context/GlobalStateContext";
import { ItemUser } from "../../resources/types";

type UserAvatarProps = {
  idUser: number;
  size?: "small" | "medium" | "large";
  width?: number;
  cache?: boolean;
  tooltip?: boolean;
};

const UserAvatar: React.FC<UserAvatarProps> = ({ idUser = 0, size = "small", width = 0, cache = false, tooltip = false }) => {
  const { data, parameters } = useGlobalState();
  let width2 = size === "small" ? 50 : size === "medium" ? 100 : 200;
  const user: ItemUser = data.users.find((u: ItemUser) => u.idUser === idUser);
  const [visible, setVisible] = React.useState(false);
  if (width > 0) width2 = width;
  return (
    <>
      <div onClick={() => setVisible(true)} style={{ width: "1%" }}>
        <Avatar
          style={{ root: { borderColor: parameters.theme === "dark" ? "#a4a4ad" : "#424650", borderWidth: '1px', borderRadius: '50%' } }}
          key={`avt-${idUser}`}
          ariaLabel={tooltip ? user ? `${user.displayName}` : "Usuario" : ""}
          tooltipText={tooltip ? user ? `${user.displayName}` : "Usuario" : ""}
          imgUrl={`https://store.planeadores.cl/images/users/${size === "small" ? "050" : "300"}.${idUser}.jpg${cache ? `?t=${new Date().getTime()}` : ""}`}
          width={width2}
        />
      </div>
      <Modal size="small"
        visible={visible}
        onDismiss={() => { setVisible(false); }}
        header={user ? user.displayName || "Sin nombre " : "Sin nombre "}
        closeAriaLabel="Cerrar modal de error de imagen"
      >
        <img
          src={`https://store.planeadores.cl/images/users/300.${idUser}.jpg${cache ? `?t=${new Date().getTime()}` : ""}`}
          alt="Profile"
          style={{
            width: '280px',
            height: '280px',
            borderRadius: '50%',
            objectFit: 'cover'    // crops the image nicely inside the circle
          }}
        />
      </Modal>
    </>
  );
};

export default UserAvatar;
